import { render, staticRenderFns } from "./CustomizeBPDefinitionImage.vue?vue&type=template&id=d195f454&"
import script from "./CustomizeBPDefinitionImage.vue?vue&type=script&lang=js&"
export * from "./CustomizeBPDefinitionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports